module.exports = __webpack_public_path__ + "img/i-seat-wc.5b254c75.svg";